import { msg } from "components/schema/msg";
import * as Yup from "yup";

export const AssignSubCategorySchema = Yup.object().shape({
  subCategories: Yup.mixed().required(msg("subCategoryRequired")),
  categories: Yup.mixed().required(msg("categoryRequired")),
});
